import React, { useEffect, useState, useContext } from 'react';
import {
  CircularProgress,
  Container,
  Typography,
  Card,
  Box,
  CardContent,
  Stack,
  Button,
  Tooltip,
    IconButton,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
  Chip,
  Alert
} from '@mui/material';
import { Edit,CreditCard,AttachFile } from '@mui/icons-material';
import contrattoApi from '../../api/contrattoApi';
import tipoContrattoApi from '../../api/tipocontrattoApi';
import pagamentoApi from '../../api/pagamentoApi';
import { useParams, useNavigate } from 'react-router-dom';
import ProtectedAction from '../../components/ProtectedAction';
import BackButtonDesktop from '../../components/BackButtonDesktop';
import { AuthContext } from '../../auth/AuthContext';
import { formatDate } from '../../utils/dateFormatter';
import ConfirmDialog from '../../components/ConfirmDeleteModal';

const statoContrattoColor = {
  ATTIVO: 'success',
  IN_ATTESA_PAGAMENTO: 'warning',
  SCADUTO: 'default',
  ANNULLATO: 'error'
};

const pagamentoStatoColor = {
  CREATO: 'default',
  IN_ATTESA: 'warning',
  PAGATO: 'success',
  FALLITO: 'error'
};

const pagamentoMetodoLabel = {
  CARTA: 'Carta',
  BONIFICO: 'Bonifico',
  PAYPAL: 'PayPal'
};
const extractErrorMessage = (error) => {
  if (!error) return 'Errore sconosciuto';
  if (error.response?.data) return JSON.stringify(error.response?.data);
  if (!error.response) {
    return "L'elaborazione richiede più tempo del previsto. Riprova.";
  }
  return error.message || JSON.stringify(error);
};

export default function ContrattoDetailPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { user } = useContext(AuthContext);
  const [err, setErr] = useState(null);
  const [contratto, setContratto] = useState(null);
  const [tipoContratto, setTipoContratto] = useState(null);
  const [loading, setLoading] = useState(true);
  const [openDelete, setOpenDelete] = useState(false);

useEffect(() => {
  const fetchContratto = async () => {
    setLoading(true);
    try {
      const r = await contrattoApi.get(id);
      setContratto(r.data);

      if (r.data.tipocontrattoId) {
        try {
          const t = await tipoContrattoApi.get(r.data.tipocontrattoId);
          setTipoContratto(t.data);
        } catch (err) {
          setErr(extractErrorMessage(err));
        }
      }
    } catch (err) {
      // Qui intercetti qualsiasi errore del controller
      const msg = extractErrorMessage(err);
      console.error("Errore fetch contratto:", msg);
      setErr(extractErrorMessage(err));
    } finally {
      setLoading(false);
    }
  };

  fetchContratto();
}, [id]);

  const annullaContratto = async () => {
    if (!window.confirm('Annullare definitivamente il contratto?')) return;
    try {
      setLoading(true);
      await contrattoApi.update(id, {
        ...form,
        dataAnnullamento: new Date().toISOString().substring(0, 10),
        attivo: false
      });
    } catch (e) {
      setErr(e.response?.data || e.message);
    } finally {
      setLoading(false);
    }
  };
  const payWithCard = async (paymentId) => {
    try {
      setLoading(true);
      const res = await pagamentoApi.payWithCard(paymentId);
      if (res.data.checkoutUrl) window.location.href = res.data.checkoutUrl;
    } catch (e) {
      setErr("Errore pagamento con carta: " + (e.response?.data || e.message));
    } finally {
           setLoading(false);
    }
  };

  const attachReceipt = async (paymentId, file) => {
      if (!file) return;
      const formData = new FormData();
      formData.append("file", file);
      try {
        setLoading(true);
        const res = await pagamentoApi.uploadFile(paymentId, formData);
        // Aggiorno pagamento
        const updated = await pagamentoApi.get(paymentId);
        setContratto(prev => ({
          ...prev,
          pagamenti: prev.pagamenti.map(p => p.id === paymentId ? updated.data : p)
        }));
      } catch (e) {
        setErr("Errore upload ricevuta: " + (e.response?.data || e.message));
      } finally {
             setLoading(false);
      }
    };

    const rinnova = async () => {
    setErr(null);
      //if (!window.confirm('Sei sicuro di voler rinnovare il contratto?')) return;
      try {
        await contrattoApi.renew(id);
        navigate(`/contratti/${id}`)
      } catch (e) {
        setErr(e.response?.data || e.message);
      } finally {
      }
    };

  if (!contratto) return <div>Contratto non trovato</div>;

  if (contratto.id!=user?.contrattoId && user?.role!="ADMIN") return <div>Non puoi visualizzare questo dato</div>;

  const scaduto = new Date(contratto.dataFine) < new Date();

  return (
    <Container maxWidth="600px">
          {loading && (
            <Box
              sx={{
                position: 'fixed',
                inset: 0,
                bgcolor: 'rgba(255,255,255,0.7)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 1300,
              }}
            >
              <CircularProgress size={48}/>
            </Box>
          )}
    <BackButtonDesktop />
      <Typography variant="h4" sx={{ mb: 2 }}>
        Dettaglio Contratto
      </Typography>
 {/* DATI CONTRATTO */}
      <Card>
        <CardContent>
          <Stack spacing={1}>
          <ProtectedAction user={user} roles={['ADMIN']}>
            <Typography>
              <strong>Utente:</strong>{' '}
              <Button
                size="small"
                onClick={() => navigate(`/users/${contratto.utenteId}`)}
              >
                Vai all’utente
              </Button>
            </Typography>
            </ProtectedAction>
            <Typography>
              <strong>Tipo contratto:</strong> {tipoContratto ? tipoContratto.tipo : '-'}
            </Typography>
            <Typography>
              <strong>Durata:</strong> {contratto.durationYears}
            </Typography>
            <Typography>
              <strong>Canone:</strong> {contratto.canoneAnnuo} €
            </Typography>

            <Typography>
              <strong>Data inizio:</strong> {formatDate(contratto.dataInizio)}
            </Typography>

            <Typography>
              <strong>Data fine:</strong> {formatDate(contratto.dataFine)}
            </Typography>

            <Typography>
              <strong>Data annullamento:</strong> {contratto.dataAnnullamento || '-'}
            </Typography>

            <Chip
              label={contratto.stato || (scaduto ? 'SCADUTO' : 'ATTIVO')}
              color={statoContrattoColor[contratto.stato] || (scaduto ? 'warning' : 'success')}
              sx={{ width: 'fit-content', mt: 1 }}
            />
          </Stack>
        </CardContent>
      </Card>
    {err && <Alert severity="error" sx={{ mb: 2 }}>{err}</Alert>}
      {/* PAGAMENTI */}
      {contratto.stato === 'IN_ATTESA_PAGAMENTO' &&
     <Alert severity="info" sx={{ mb: 2 }}>
     <Typography sx={{ mb: 2 }}>Si può effettuare il pagamento in due modalità:</Typography>
     <Typography sx={{ mb: 2 }}>- bonifico bancario. Effettuare un bonifico verso IBAN: IT56 H034 4003 2140 0000 0921 100, intestato a CO.S.F.IMP. S.R.L.S., causale "saldo abbonamento",
     e allegare la ricevuta di pagamento in questa pagina. L'amministrazione verificherà l'effettiva esecuzione
       del pagamento ed attiverà il contratto.</Typography>
     {user.stripeenabled && '- pagamento con carta (Stripe). cliccare sul bottone PAGA CON CARTA (icona carta di credito nelle azioni del pagamento). Si viene indirizzati alla pagina Stripe per il pagamento con carta. Al termine della transazione si viene mandati su una pagina di conferma di pagamento e il contratto sarà attivato.'}</Alert>
     }

            {/* AZIONI */}
            <Stack direction="row" spacing={2} sx={{ mt: 3 }}>
                    {scaduto && user.role === "ADMIN" && (
                      <Button
                        variant="contained"
                        color="warning"
                        onClick={rinnova}
                      >
                        Rinnova contratto
                      </Button>
                    )}
            </Stack>
   {contratto.stato === 'IN_ATTESA_PAGAMENTO' && (
      <>
    <Stack direction="row" spacing={1} sx={{ mt: 2 }}>
      {[1,2,3,4].map(y => (
        <Button
          key={y}
          variant={contratto.durationYears === y ? 'contained' : 'outlined'}
          onClick={async () => {
            try {
              const res = await contrattoApi.updateDuration(contratto.id, y);
              setContratto(res.data); // aggiorno stato con contratto aggiornato
            } catch (e) {
              alert("Errore aggiornamento durata: " + (e.response?.data || e.message));
            }
          }}
        >
          {y} ann{y > 1 ? 'i' : 'o'} {y ==2 ? '(sconto 15%)':''} {y ==3? '(sconto 20%)':''} {y ==4? '(sconto 25%)':''}
        </Button>
      ))}
    </Stack>
     </>
     )}
      <Card sx={{ mt: 6 }}>
        <CardContent>
          <Typography variant="h6" sx={{ mb: 1 }}>
            Pagamenti
          </Typography>

          {(!contratto.pagamenti || contratto.pagamenti.length === 0) && (
            <Typography color="text.secondary">
              Nessun pagamento presente
            </Typography>
          )}

          <Stack spacing={1}>
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell>Importo</TableCell>
                          <TableCell>Stato</TableCell>
                          <TableCell>Metodo</TableCell>
                          <TableCell>Data Pagamento</TableCell>
                          <TableCell>Periodo Inizio</TableCell>
                          <TableCell>Periodo Fine</TableCell>
                          <TableCell>Azioni</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {contratto.pagamenti.map((p, idx) => (
                          <TableRow key={idx}>
                            <TableCell>{p.importo} €</TableCell>
                            <TableCell>{p.stato}</TableCell>
                            <TableCell>{p.metodo}</TableCell>
                            <TableCell>{p.dataPagamento?formatDate(p.dataPagamento):'-'} </TableCell>
                            <TableCell>{formatDate(p.periodoInizio)}</TableCell>
                            <TableCell>{formatDate(p.periodoFine)}</TableCell>
                              <TableCell>
                       <Stack direction="row" spacing={1}>
                            {/* Solo per pagamenti IN_ATTESA mostro le redazioni */}
                {p.stato === 'IN_ATTESA' && (
                  <>
                    {user.stripeenabled && (
                    <Tooltip title="paga con carta">
                      <IconButton
                        color="primary"
                        size="small"
                        onClick={async () => {
                          try {
                            setLoading(true);
                            const res = await pagamentoApi.payWithCard(p.id);
                            if (res.data.checkoutUrl) {
                              window.location.href = res.data.checkoutUrl;
                            }
                          } catch (e) {
                            alert("Errore pagamento con carta: " + (e.response?.data || e.message));
                          } finally {
                              setLoading(false);
                          }
                        }}
                      >
                        <CreditCard /> {/* import @mui/icons-material/CreditCard */}
                      </IconButton>
                      </Tooltip>
                    )}
                    <IconButton
                      color="secondary"
                      size="small"
                      component="label"
                    >
                      <AttachFile /> {/* import @mui/icons-material/AttachFile */}
                      <input
                        type="file"
                        hidden
                        accept=".pdf"
                        onChange={async (e) => {
                          const file = e.target.files[0];
                          if (!file) return;
                          const formData = new FormData();
                          formData.append("file", file);
                          try {
                            setLoading(true);
                            const res = await pagamentoApi.uploadFile(p.id, formData);
                            alert("File caricato: " + res.data.fileName);
                            // aggiornare lo stato del pagamento se serve
                          } catch (err) {
                            alert("Errore upload: " + (err.response?.data || err.message));
                          } finally {
                            setLoading(false);
                          }
                        }}
                      />
                    </IconButton>
                  </>
                )}
                        {user.role === "ADMIN" && (
                        <IconButton color="secondary" size="small" onClick={() => navigate(`/pagamenti/edit/${p.id}`)}>
                          <Edit />
                        </IconButton>
                        )}
                                </Stack>
                              </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
          </Stack>
        </CardContent>
      </Card>


    </Container>
  );
}
